import { jwtDecode } from "jwt-decode";

/**
 * Render-gate for the Tasks dashboard section, BootNav create-task button,
 * mention pickers, and assignee dropdowns.
 *
 * Returns true ONLY when the user's JWT carries `features.tasks === true`.
 * Non-tasks-feature users can never:
 *   - see the dashboard Tasks section
 *   - be selected in the assignee dropdown (server-filtered too)
 *   - be @mentioned (server filters mentions)
 *   - create a task from the BootNav button
 *
 * Mirrors the pattern used in ClinicalHistory/access.js — JWT-based, so a
 * stale token after a server-side feature change still gates correctly until
 * the next login. UX-only; tasksRoutes.js enforces the same gate at the API
 * layer (requireTasksFeature middleware) regardless of what the client does.
 */
export function userCanUseTasks() {
  try {
    const token = sessionStorage.getItem("user");
    if (!token) return false;
    const decoded = jwtDecode(token);
    return !!decoded?.features?.tasks;
  } catch (_e) {
    return false;
  }
}
